export default class Shape {
  #id;
  #name;
  #type;
  #isAnnoteted;
  #annotationName;
  #position;

  constructor(id, name, type, position) {
    this.#id = id;
    this.#name = name;
    this.#type = type;
    this.#isAnnoteted = false;
    this.#annotationName = '';
    this.#position = position;
  }

  setId(id) {
    this.#id = id;
  }

  getId() {
    return this.#id;
  }

  setName(name) {
    this.#name = name;
  }

  getName() {
    return this.#name;
  }

  setType(type) {
    this.#type = type;
  }

  getType() {
    return this.#type;
  }

  setAsAnnotated() {
    this.#isAnnoteted = true;
  }

  setAsNotAnnotated() {
    this.#isAnnoteted = false;
  }

  getIsAnnotated() {
    return this.#isAnnoteted;
  }

  setAnnotatedName(name) {
    this.#annotationName = name;
  }

  getAnnotatedName() {
    return this.#annotationName;
  }

  setPosition(position = { x: 0, y: 0 }) {
    this.#position = position;
  }

  getPosition() {
    return this.#position;
  }
}
